// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ck-z","tupacHeader":"Dk-z","tupacHeader2":"Ek-z","tupacMenu":"Fk-z","tupacMenu2":"Gk-z","tupacMain":"Hk-z","tupacMain2":"Ik-z"};